<template>

  <div>

      <div class="list-group-item" data-toggle="collapse">

          <div v-for="(row, key) in rows" class="row">
            <div class="col-xs-3">

                <label class="control-label">{{ row.name }}</label>

            </div>
            <div class="col-xs-3">

                <div class="form-group">
                    <label class="control-label">Pris</label>
                    <input type="text" class="form-control" v-model="row.price" />
                </div>

            </div>
            <div class="col-xs-3">
              
                <div class="form-group">
                    <label class="control-label">Gäller från</label>
                    <input type="text" class="form-control" v-model="row.valid_from" />
                </div>

            </div>

            <div class="col-xs-2">
                <button type="button" class="btn btn-xs btn-primary" v-on:click="save(row)">Spara</button>
            </div>

          </div>

      </div>

     

  </div>

</template>


<script>

export default {
    created: function() {
        console.log('how often does this render?');
    },
    props: {
        item: {

            required: true

        },
        settings: {

            required: true

        }

    },
    data: function() {

        return {

            rows: this.settings.extraData.affiliates,

        }
    },
    methods: {

        save: function(row) {

            var self = this;

            console.log(self.item);
            console.log(row);

            var product_id = self.item.id;
            var affiliate_id = row.id;
            var valid_from = row.valid_from;
            var price = row.price;


            this.$http.post('/products/setPrice', { product_id:product_id, affiliate_id:affiliate_id, valid_from:valid_from, price:price   }).then((response) => {

                console.log(response.body);

            }, (response) => {
                console.log(JSON.stringify(response));
            });

        }
       

    }
}

</script>